import React from 'react'
import { CustomSwitch } from './EditDevice/ParametersTable'
import ModelPopup from '../../../components/Modal'
import { type SxProps, type Theme } from '@mui/material'

const TogglePolling = (props: AllProps): JSX.Element => {
  const [enableModel, setEnableModel] = React.useState(false)
  const [enablePolling, setEnablePolling] = React.useState(props.checked ?? false)
  return (<>
        {enableModel && (
            <ModelPopup
            buttonTypeNegative='hollow'
            buttonTypePositive='filled'
            title={'Device Status'}
            LabelNegative={'Cancel'}
            LabelPositive={'Confirm'}
            height='235px'
            onClickPositive={() => {
              setEnableModel(false)
              props?.onChange(enablePolling)
            }}
            onClickNegative={() => {
              setEnableModel(false)
              setEnablePolling(!enablePolling)
            }}
            onClose={() => {
              setEnableModel(false)
              setEnablePolling(!enablePolling)
            }}
            >
            <p style={{ paddingTop: '1.2em' }}>
              {enablePolling
                ? <span>Are you sure you want to Enable Polling? <br/><br/> Enabling polling will initiate process, once enabled will allow the device to start transmitting data.</span>
                : <span>Are you sure you want to Disable Polling? <br/><br/> Disabling polling will initiate process, once disabled will stop the device from transmitting data. </span>}
            </p>
            </ModelPopup>
        )}
      <CustomSwitch sx={props.sx}
            checked={enablePolling}
            disabled={props.disabled}
            size="medium"
            data-testid={'select-switch'}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setEnablePolling(event.target.checked)
              setEnableModel(true)
            }} />
  </>)
}

interface InputProps {
  sx?: SxProps<Theme>
  checked?: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
}

type AllProps = InputProps

export const MemoTogglePolling = React.memo(TogglePolling)
